import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-invalid-permissions',
  templateUrl: './invalid-permissions.component.html',
})
export class InvalidPermissionsComponent implements OnInit {

  errorMessage: string | null = "";

  constructor(
    private aRoute: ActivatedRoute,
  ) {}

  ngOnInit() {

    this.aRoute.parent!.paramMap.subscribe(params => {
      this.errorMessage = params.get('error');
      console.log(this.errorMessage);
    });
  }    

  isError(): boolean {
    return (this.errorMessage) ? true : false;
  }
}  